module.exports = __webpack_public_path__ + "img/login_drone_on_map.f1ff9fd2.svg";